import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthRedirectService } from './auth-redirect.service';

/**
 * Catches unknown/invalid URLs (wildcard route). Authenticated users are sent
 * to the dashboard, unauthenticated users are sent to /login, so no route
 * ever renders a broken/blank page.
 */
@Injectable({
  providedIn: 'root',
})
export class NotFoundGuard implements CanActivate {
  constructor(private router: Router, private authRedirectService: AuthRedirectService) { }

  canActivate(): UrlTree {
    return this.authRedirectService.isAuthenticated()
      ? this.router.createUrlTree(['/dashboard'])
      : this.router.createUrlTree(['/login']);
  }
}